export default __webpack_public_path__ + "static/media/leafcuttingbee.12f00561.jpg";